import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, PageEvent } from '@angular/material';
import { AppService } from 'src/@core/services/app.service';
import { AssignMembersComponent } from './assign-members/assign-members.component';

@Component({
  selector: 'hour4u-admin-assigned-members',
  templateUrl: './assigned-members.component.html',
  styleUrls: ['./assigned-members.component.scss']
})
export class AssignedMembersComponent implements OnInit {
  @Input() data: any;
  rolesDataSource: any[] = [];
  columns = [
    { columnDef: 'name', visible: true, label: 'Name' },
    // { columnDef: 'description', visible: true, label: 'Description' },
    // { columnDef: 'permissions', visible: true, label: 'Permissions' },
  ];
  displayedColumns = [...this.columns.map(x => x.columnDef), 'actions'];
  profile = this.appService.getCurrentAccount();
  isLoading: boolean = false;
  searchByName: any = null;
  timeoutRef: ReturnType<typeof setTimeout>;
  selectedAll: boolean = false;
  selectedTeamMembers = [];

  constructor(
    private dialog: MatDialog,
    private appService: AppService
  ) { }

  ngOnInit() {
    console.log(this.data);
  }

  // clear Search
  clearSearch() {
    this.searchByName = "";
    this.ngOnInit();
  }

  // earch on briefing Form name
  search() {
    clearTimeout(this.timeoutRef);
    this.timeoutRef = setTimeout(() => {
      this.ngOnInit();
    }, 700);
  }

  // on Form Row Click
  onFormRowClick(row) {

  }

  // onPageChange(event: PageEvent): void {
  //   console.log(event.pageIndex, event.pageSize)
  //   this.pageIndex = event.pageIndex;
  //   this.pageSize = event.pageSize;
  //   this.ngOnInit();
  // }

  // add team member
  addTeamMember() {
    let obj = Object.assign({});
    obj.actionTitle = "Add Members";
    const dialogRef = this.dialog.open(AssignMembersComponent, {
      width: '600px',
      panelClass: 'add-edit-role-dialog',
      disableClose: true,
      data: obj,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.ngOnInit();
      }
    });
  }

  deleteTeamMember(element) {

  }

  editRole(element) {

  }

  // Get Initial letter from JobSeeker name
  getUserNameInitial(full_name) {
    let initialOfName = null;
    if (full_name) {
      if (full_name.split(' ').length == 1) {
        initialOfName = full_name.split(' ')[0].split('')[0];
      }
      if (full_name.split(' ').length > 1) {
        initialOfName = full_name.split(' ')[0].split('')[0] + (full_name.split(' ')[1].split('')[0] ? full_name.split(' ')[1].split('')[0] : '')
      }
      return initialOfName ? initialOfName : full_name.split('')[0];
    }
  }

}
